import React from 'react';
import { useSelectPrecipitationTypeFieldQuery } from 'generated/graphql';

export type IData = {
  id: string;
  name: string;
  displayName: string;
};

export function useQuery() {
  const tuple = useSelectPrecipitationTypeFieldQuery();

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.precipitationTypes?.map((node) => ({
        id: node?.id ?? '',
        name: node?.name ?? '',
        displayName: node?.displayName ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
